import React, { useRef, useState } from "react";
import axios from "axios";
import "./Translate.css";
import PopupWindow from "./PopupWindow";

const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;

const Translate = () => {
  const BASEURL = {
    GET_PAGEJSON: `${apiEndpoint}/api/get-pagejson`,
    TRANSLATE_JSON: `${apiEndpoint}/api/translate-json`,
    GET_PROMPT: `${apiEndpoint}/api/get-live-prompt`,
    CHECK_JOB_STATUS: `${apiEndpoint}/api/check-job-status`,
  };
  // const BASEURL = {
  //   GET_PAGEJSON: "http://localhost:8000/api/get-pagejson",
  //   TRANSLATE_JSON: "http://localhost:8000/api/translate-json",
  //   GET_PROMPT: "http://localhost:8000/api/get-live-prompt",
  //   CHECK_JOB_STATUS: "http://localhost:8000/api/check-job-status",
  // };

  const [url, setUrl] = useState("");
  const [originalText, setOriginalText] = useState("");
  const [translatedText, setTranslatedText] = useState("");
  const [Language, setLanguage] = useState("Simplified Chinese");
  const [loading, setLoading] = useState(false); //Add loading effect.
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [model, setModel] = useState("gpt-4o-mini")
  const [BlogPromptText, setBlogPromptText] = useState("");
  const [KbPromptText, setKbPromptText] = useState("");
  const [ReviewPrompt, setReviewPromptText] = useState("");
  const [BlogTemperature, setBlogTemperature] = useState(0.7);
  const [KbTemperature, setKbTemperature] = useState(0.7);
  const [ReviewTemperature, setReviewTemperature] = useState(0.7);
  /**
 * Opens the popup by setting the state variable `isPopupOpen` to true.
 * This function is typically called when the user triggers an action that
 * requires the popup to be displayed, such as clicking a button.
 */
  const openPopup = () => {
    setIsPopupOpen(true);
  };
/**
 * Closes the popup by setting the state variable `isPopupOpen` to false.
 * This function is usually called when the user wants to dismiss the popup,
 * such as by clicking a close button or outside the popup area.
 */
  const closePopup = () => {
    setIsPopupOpen(false);
  };
/**
 * Handles the save action by updating various state variables with data from
 * the input parameter. This function is called when the user saves or submits
 * the form data from the popup.
 *
 * @param {Object} data - The data object containing the content and temperature
 *                        for different prompt types.
 * @param {Object} data.prompt1 - Data related to the blog prompt.
 * @param {string} data.prompt1.content - The content of the blog prompt.
 * @param {number} data.prompt1.temperature - The temperature setting for the blog prompt.
 * @param {Object} data.prompt2 - Data related to the knowledge base (KB) prompt.
 * @param {string} data.prompt2.content - The content of the KB prompt.
 * @param {number} data.prompt2.temperature - The temperature setting for the KB prompt.
 * @param {Object} data.prompt3 - Data related to the review prompt.
 * @param {string} data.prompt3.content - The content of the review prompt.
 * @param {number} data.prompt3.temperature - The temperature setting for the review prompt.
 */
  const handleSave = (data) => {
    setBlogPromptText(data.prompt1.content);
    setKbPromptText(data.prompt2.content);
    setReviewPromptText(data.prompt3.content);
    setBlogTemperature(data.prompt1.temperature);
    setKbTemperature(data.prompt2.temperature);
    setReviewTemperature(data.prompt3.temperature);

  };
  const handlePreview = async () => {
    try {
      try {
        if (!url) {
          throw new Error("URL cannot be empty. Please provide a URL.");
        }
      } catch (error) {
        console.error("Error fetching markdown:", error);
        alert(`Error: ${error.message}`);
      }
      const response = await axios.get(`${BASEURL.GET_PAGEJSON}?url=${url}`, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      setOriginalText(response.data);
      let markdownData = response.data;
      console.log(markdownData);
      setOriginalText(JSON.stringify(markdownData, null, 2));
    } catch (error) {
      console.error("Error fetching markdown:", error);
    }
  };
/**
 * Initiates the translation process by sending a request to the translation API.
 * It first checks if there is original text to translate, then makes an asynchronous
 * request to the API. If the request is successful, it starts polling the job status
 * until the translation is complete or fails.
 *
 * @throws {Error} If there is no original text or the network response is not as expected.
 */
  const handleTranslate = async () => {
    setLoading(true);
    console.log("Sending request: ", {
      Original: originalText,
      Language: Language,
      PromptText: BlogPromptText,
      KbPromptText: KbPromptText,
      reviewPromptText: ReviewPrompt,
      url: url,
    });
    try {
      if (!originalText) {
        throw new Error(
          "No data retrieved. Please use Preview button retrieve the data first."
        );
      }

      const response = await axios.post(
        BASEURL.TRANSLATE_JSON,
        {
          Original: originalText,
          Language: Language,
          PromptText: BlogPromptText,
          KbPromptText: KbPromptText,
          reviewPromptText: ReviewPrompt,
          BlogTemperature:BlogTemperature,
          KbTemperature:KbTemperature,
          ReviewTemperature:ReviewTemperature,
          url: url,
          model: model,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      pollJobStatus(response.data.job_id);
      if (response.status !== 202) {
        console.log(response);
        throw new Error("Network response was not ok");
      }
    } catch (error) {
      console.error("Error translating markdown:", error);
      alert(`Error: ${error.message}`);
    }
  };
  /**
 * Polls the status of the translation job using a job ID. It sends a request
 * to the job status endpoint every 10 seconds until the job is either completed or failed.
 * If completed, it sets the translated text in the state. If failed, it throws an error.
 *
 * @param {string} jobId - The unique identifier of the translation job.
 * @throws {Error} If the job status is failed or network response is not as expected.
 */
  const pollJobStatus = (jobId) => {
    const intervalId = setInterval(async () => {
      try {
        const response = await axios.get(
          `${BASEURL.CHECK_JOB_STATUS}/${jobId}`
        );

        if (response.status !== 200) {
          throw new Error("Network response was not ok");
        }
        const jobStatus = response.data.status;

        if (jobStatus === "completed") {
          if (response.data.result.status_code !== 200) {
            console.log(response.data.result.message);
            throw new Error(response.data.result.message);
          }
          clearInterval(intervalId);
          setTranslatedText(JSON.stringify(response.data.result.data, null, 2));
          setLoading(false);
          console.log("Translation completed:", response.data.result);
        } else if (jobStatus === "failed") {
          clearInterval(intervalId);
          setLoading(false);
          throw new Error(response.data.message || "Translation job failed");
        }
      } catch (error) {
        clearInterval(intervalId);
        console.error("Error polling job status:", error);
        alert(`Error polling job status: ${error.message}`);
        setLoading(false);
      }
    }, 10000); // 每10秒轮询一次
  };
  const textBoxRef = useRef(null);
/**
 * Copies the translated text to the clipboard. It utilizes the Clipboard API
 * to copy the content and shows an alert message if successful.
 *
 * @throws {Error} If the clipboard operation fails.
 */
  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(translatedText);
      alert("Copied to clipboard");
    } catch (err) {
      console.error("Failed to copy：", err);
    }
  };
/**
 * Handles the change in the language selection dropdown. It updates the state
 * with the new language value selected by the user.
 *
 * @param {Object} event - The event object from the dropdown selection.
 * @param {string} event.target.value - The selected language value.
 */
  const handleLanguage = (event) => {
    setLanguage(event.target.value);
    console.log(Language);
  };

  const handleModel = (event) => {
    setModel(event.target.value);
    console.log(model)
  }

  return (
    <div className="Translate">
      <header className="Translate-header"></header>
      <div className="Urls">
        {/* <input
          type="text"
          placeholder="input URL"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          className="url-input"
        />
        <button onClick={handlePreview}>Preview</button> */}
      </div>

      <div className="controls">
        <div className="control-group">
          <h3>Select Language</h3>
          <select value={Language} onChange={handleLanguage}>
            <option value="Simplified Chinese">Simplified Chinese</option>
            <option value="Japanese">Japanese</option>
            <option value="Traditional Chinese">Traditional Chinese</option>
            <option value="Arabic">Arabic</option>
            <option value="Czech">Czech</option>
            <option value="German">German</option>
            <option value="Spanish">Spanish</option>
            <option value="Finnish">Finnish</option>
            <option value="French">French</option>
            <option value="Indonesian">Indonesian</option>
            <option value="Italian">Italian</option>
            <option value="Dutch">Dutch</option>
            <option value="Norwegian">Norwegian</option>
            <option value="Polish">Polish</option>
            <option value="Portuguese">Portuguese</option>
            <option value="Romanian">Romanian</option>
            <option value="Slovak">Slovak</option>
            <option value="Swedish">Swedish</option>
            <option value="Vietnamese">Vietnamese</option>
            <option value="Korean">Korean</option>
            <option value="Russian">Russian</option>
          </select>
        </div>

        <div className="control-group">
          <h3>Select Model</h3>
          <select value={model} onChange={handleModel}>
            <option value="gpt-4o-mini">gpt-4o-mini</option>
            <option value="gpt-4o">gpt-4o</option>
          </select>
        </div>

        <div className="control-group">
          <h3>Translate</h3>
          <button
            onClick={handleTranslate}
            disabled={loading}
            className={loading ? "loading-button" : ""}
          >
            {loading ? "Translating..." : "Translate"}
          </button>
        </div>

        <div className="control-group">
          <h3>Copy</h3>
          <button onClick={copyToClipboard}>Copy Translation</button>
        </div>

        <div className="control-group">
          <h3>Edit Prompt</h3>
          <button onClick={openPopup}>Edit Prompt</button>
          <PopupWindow
            isOpen={isPopupOpen}
            onClose={closePopup}
            onSave={handleSave}
            initialContent1={BlogPromptText}
            initialContent2={KbPromptText}
            initialContent3={ReviewPrompt}
            url={`${BASEURL.GET_PROMPT}?language=${Language}&model=${model}`}
          />
        </div>
      </div>
      <div className="text-display">
        <div className="text-section">
          <h3>Original</h3>
          <textarea
            className="text-box"
            value={originalText}
            onChange={(e) => setOriginalText(e.target.value)}
          />
        </div>
        <div className="text-section">
          <h3>Translation</h3>
          <pre className="text-box" id="Translation" ref={textBoxRef}>
            {translatedText}
          </pre>
        </div>
      </div>
      <header className="Translate-header">
        Version: {process.env.REACT_APP_COMMIT_SHA}
      </header>
    </div>
  );
};

export default Translate;
